module.exports = __webpack_public_path__ + "media/bootstrap-icons/emoji-expressionless-fill-6474fd6a.svg";